class MegaMenuFeaturedSubmenu {
  constructor(root) {
    this.root = root;
    this.listWrap = root.querySelector('.mega-menu-featured__list-wrap') || root;
    this.onClick = this.onClick.bind(this);
    this.onParentToggle = this.onParentToggle.bind(this);

    this.root.addEventListener('click', this.onClick);

    const parentDetails = this.root.closest('.nav-item')?.querySelector(
      ':scope > header-menu-trigger > details'
    );
    parentDetails?.addEventListener('toggle', this.onParentToggle);
  }

  onClick(event) {
    const openTrigger = event.target.closest('[data-featured-submenu-open]');
    if (openTrigger && this.root.contains(openTrigger)) {
      event.preventDefault();
      event.stopPropagation();

      const submenu = openTrigger.nextElementSibling;
      if (!submenu?.matches('[data-featured-submenu]')) return;

      const parentPanel = openTrigger.closest('[data-featured-submenu]');
      const scope = parentPanel || this.listWrap;

      scope.querySelectorAll('[data-featured-submenu].is-active').forEach((active) => {
        if (active === submenu || submenu.contains(active) || active.contains(submenu)) return;
        active.classList.remove('is-active');
        active.previousElementSibling?.setAttribute('aria-expanded', 'false');
      });

      submenu.classList.add('is-active');
      this.listWrap.classList.add('has-active-submenu');
      openTrigger.setAttribute('aria-expanded', 'true');
      return;
    }

    const closeTrigger = event.target.closest('[data-featured-submenu-close]');
    if (!closeTrigger || !this.root.contains(closeTrigger)) return;

    event.preventDefault();
    event.stopPropagation();

    const submenu = closeTrigger.closest('[data-featured-submenu]');
    if (!submenu) return;

    submenu.querySelectorAll('[data-featured-submenu].is-active').forEach((nestedSubmenu) => {
      nestedSubmenu.classList.remove('is-active');
      nestedSubmenu.previousElementSibling?.setAttribute('aria-expanded', 'false');
    });
    submenu.classList.remove('is-active');
    submenu.previousElementSibling?.setAttribute('aria-expanded', 'false');

    if (!this.listWrap.querySelector('[data-featured-submenu].is-active')) {
      this.listWrap.classList.remove('has-active-submenu');
    }
  }

  closeAllSubmenus() {
    this.root.querySelectorAll('[data-featured-submenu].is-active').forEach((submenu) => {
      submenu.classList.remove('is-active');
    });
    this.root.querySelectorAll('[data-featured-submenu-open]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.listWrap.classList.remove('has-active-submenu');
  }

  onParentToggle(event) {
    if (!event.target.open) {
      this.closeAllSubmenus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu-featured').forEach((root) => {
    new MegaMenuFeaturedSubmenu(root);
  });
});
